module.exports = __webpack_public_path__ + "bf704b62912da91d8c21f802734be36e.svg";